"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var core_1 = require("@material-ui/core");

var styles_1 = require("@material-ui/core/styles");

var login_styles_1 = require("./login-styles");

var LoginLayout = function LoginLayout(props) {
  var theme = styles_1.useTheme();
  return react_1.default.createElement(core_1.Grid, {
    container: true,
    spacing: 0,
    direction: "column",
    alignItems: "center",
    justify: "center",
    style: {
      minHeight: '100vh',
      backgroundColor: theme.palette.primary.main
    }
  }, react_1.default.createElement(core_1.Grid, {
    item: true,
    xs: 12
  }, react_1.default.createElement("h1", {
    style: {
      color: 'white',
      textAlign: 'center'
    }
  }, props.title), react_1.default.createElement(login_styles_1.FormContainer, null, props.children)));
};

exports.default = LoginLayout;